module.exports = __webpack_public_path__ + "static/media/65 - PPI Prancis.bfc0df0c.jpg";